import { createContext } from "react";
export default createContext({
  transformURL: url => url
});